import { Box, Flex, Image, Link, Text, VStack } from '@chakra-ui/core';
import { CheckIcon } from '@chakra-ui/icons';
import React from 'react';
import LogoImage from '../assets/logo.png';

const Step = ({ step, num, complete }) => {
  return (
    <Flex alignItems="center" zIndex={1}>
      {complete ? (
        <CheckIcon
          color="white"
          boxSize="24px"
          backgroundColor="blue.600"
          borderRadius="100px"
          mr={6}
          p="4px"
        />
      ) : (
        <Flex
          borderRadius="100%"
          boxSize="24px"
          marginRight={6}
          flexShrink={0}
          alignItems="center"
          justifyContent="center"
          color="black"
          fontSize="12px"
          fontWeight="bold"
          backgroundColor="white"
        >
          {num}
        </Flex>
      )}

      <Text textTransform="uppercase" fontWeight="bold" fontSize="12px">
        {step}
      </Text>
    </Flex>
  );
};

interface StepSidebarProps {
  steps: { [stepName: string]: number };
  step: number;
}

const StepSidebar = ({ steps, step }: StepSidebarProps) => {
  const stepNames = Object.keys(steps);
  return (
    <Box width="300px" backgroundColor="blue.400" color="white" p={8}>
      <Link href="https://atomic.finance/odds" target="_blank">
        <Image src={LogoImage} />
      </Link>
      <VStack alignItems="flex-start" spacing={6} position="relative" mt="30px">
        <Box
          width="1px"
          height="75%"
          background="#5a5a5a"
          left="11px"
          top="30px"
          position="absolute"
        />
        {stepNames.map((val, i) => (
          <Step step={val} num={i + 1} complete={step > steps[val]} />
        ))}
      </VStack>
    </Box>
  );
};

export default StepSidebar;
